import DataModel from '../../common/model/DataModel';

import PreferenceManager from '../../application/PreferenceManager';

export default class FlexHoursSummaryDataModel extends DataModel {
  constructor(preferenceGroupName) {
    super();

    this.preferenceGroupName = preferenceGroupName;

    this.showHourUnits = PreferenceManager.retrieveValue(
      this.preferenceGroupName,
      PreferenceManager.ShowHourUnits,
      false
    );

    this.contracts = [];
    this.isAllocationExceeded = false;
  }

  onPropertyUpdated(propertyName, oldValue, newValue) {
    switch (propertyName) {
      case 'showHourUnits':
        PreferenceManager.updateValue(
          this.preferenceGroupName,
          PreferenceManager.ShowHourUnits,
          newValue
        );
        break;
      default:
        break;
    }
  }
}